import { useInfiniteTournamentActivitiesQuery } from "../react-query/queries/use-result-activities";

export function useSequentialWeekActivities(
  weekSections: {
    startDate: string;
    endDate: string;
  }[],
  enabled: boolean
) {
  const [section0, section1, section2] = weekSections;

  const thisWeekQuery = useInfiniteTournamentActivitiesQuery({
    startDate: section0.startDate,
    endDate: section0.endDate,
    enabled,
  });

  const isThisWeekFullyLoaded =
    enabled &&
    thisWeekQuery.query.isSuccess &&
    !thisWeekQuery.query.hasNextPage;

  const lastWeekQuery = useInfiniteTournamentActivitiesQuery({
    startDate: section1.startDate,
    endDate: section1.endDate,
    enabled: isThisWeekFullyLoaded,
  });

  const isLastWeekFullyLoaded =
    isThisWeekFullyLoaded &&
    lastWeekQuery.query.isSuccess &&
    !lastWeekQuery.query.hasNextPage;

  const twoWeeksAgoQuery = useInfiniteTournamentActivitiesQuery({
    startDate: section2.startDate,
    endDate: section2.endDate,
    enabled: isLastWeekFullyLoaded,
  });

  const isTwoWeeksAgoFullyLoaded =
    isLastWeekFullyLoaded &&
    twoWeeksAgoQuery.query.isSuccess &&
    !twoWeeksAgoQuery.query.hasNextPage;

  const sectionQueries: ReturnType<typeof useInfiniteTournamentActivitiesQuery>[] = [
    thisWeekQuery,
    lastWeekQuery,
    twoWeeksAgoQuery,
  ];

  const sectionFullyLoaded = [
    isThisWeekFullyLoaded,
    isLastWeekFullyLoaded,
    isTwoWeeksAgoFullyLoaded,
  ];

  const allFullyLoaded = sectionFullyLoaded.every(Boolean);

  //empty state is only shown if all sections are fully loaded and none have records
  const isEmpty =
    allFullyLoaded && sectionQueries.every((q) => q.records.length === 0);

  return { sectionQueries, sectionFullyLoaded, allFullyLoaded, isEmpty };
}
